import {
  EditAction,
  MAX_HISTORY_DEPTH,
  type HistoryEntry,
  type HistorySnapshot,
  type HistoryState,
} from '@/core/history/types'

function documentsEqual(first: HistorySnapshot['document'], second: HistorySnapshot['document']): boolean {
  return JSON.stringify(first) === JSON.stringify(second)
}

export function snapshotsEqual(first: HistorySnapshot, second: HistorySnapshot): boolean {
  return documentsEqual(first.document, second.document) && first.selectedNodeId === second.selectedNodeId
}

export function pushHistory(
  history: HistoryState,
  committed: HistorySnapshot,
  action: EditAction = EditAction.GenericEdit,
): HistoryState {
  if (!Object.values(EditAction).includes(action)) {
    throw new Error(`Unknown edit action: "${String(action)}"`)
  }
  return {
    past: [...history.past, { snapshot: committed, action }].slice(-MAX_HISTORY_DEPTH),
    future: [],
  }
}

export function undoHistory(
  history: HistoryState,
  current: HistorySnapshot,
): { history: HistoryState; restored: HistorySnapshot; action: EditAction } {
  const entry = history.past.at(-1)
  if (!entry) throw new Error('Cannot undo because history is empty')
  return {
    history: {
      past: history.past.slice(0, -1),
      future: [{ snapshot: current, action: entry.action }, ...history.future],
    },
    restored: entry.snapshot,
    action: entry.action,
  }
}

export function redoHistory(
  history: HistoryState,
  current: HistorySnapshot,
): { history: HistoryState; restored: HistorySnapshot; action: EditAction } {
  const [entry, ...remainingFuture] = history.future
  if (!entry) throw new Error('Cannot redo because history is empty')
  const pastEntry: HistoryEntry = { snapshot: current, action: entry.action }
  return {
    history: {
      past: [...history.past, pastEntry].slice(-MAX_HISTORY_DEPTH),
      future: remainingFuture,
    },
    restored: entry.snapshot,
    action: entry.action,
  }
}
